import apiClient, { unwrap } from './client'
import type { Template } from './types'

export const templatesApi = {
  list(domainId?: number | null) {
    const params = domainId != null ? `?domain_id=${domainId}` : ''
    return unwrap<Template[]>(apiClient.get(`/templates${params}`))
  },

  get(id: number) {
    return unwrap<Template>(apiClient.get(`/templates/${id}`))
  },

  create(data: Partial<Template>) {
    return unwrap<{ id: number }>(apiClient.post('/templates', data))
  },

  update(id: number, data: Partial<Template>) {
    return unwrap<unknown>(apiClient.put(`/templates/${id}`, data))
  },

  /** 复制模板到其它收件域 */
  copy(id: number, data: { target_domain_ids: number[]; overwrite: boolean }) {
    return unwrap<{ domain_id: number; action: string; error?: string }[]>(apiClient.post(`/templates/${id}/copy`, data))
  },

  /** 从回收站恢复模板 */
  restore(id: number) {
    return unwrap<{ id: number; restored: boolean }>(apiClient.put(`/templates/${id}/restore`, {}))
  },

  review(id: number, action: 'submit' | 'approve' | 'reject') {
    return unwrap<unknown>(apiClient.put(`/templates/${id}/review`, { action }))
  },

  /** 启用/停用模板（active 开关，与审核状态正交） */
  setActive(id: number, active: boolean) {
    return unwrap<{ id: number; active: boolean }>(apiClient.put(`/templates/${id}/active`, { active }))
  },

  remove(id: number) {
    return unwrap<{ deleted: boolean }>(apiClient.delete(`/templates/${id}`))
  },

  uploadAttachment(id: number, file: File) {
    const form = new FormData()
    form.append('file', file)
    return unwrap<unknown>(apiClient.post(`/templates/${id}/attachments`, form))
  },

  deleteAttachment(attId: number) {
    return unwrap<{ deleted: boolean }>(apiClient.delete(`/attachments/${attId}`))
  },
}
